"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sets up the given module by calling the exported `setup` function
 * on the module.
 * @param app The module's evaluated content.
 * @param api The generated API for the module.
 */
function setupModule(app, api) {
    try {
        app.setup(api);
    }
    catch (e) {
        console.error(`Error while setting up ${app && app.name}.`, e);
    }
}
exports.setupModule = setupModule;
